module.exports = __webpack_public_path__ + "img/highlight_got.915b8eef.png";